// Brazil (America/Sao_Paulo) = UTC-3, no DST since April 2019
const BRAZIL_OFFSET_MS = -3 * 60 * 60 * 1000;

function _brazilDate() {
  return new Date(Date.now() + BRAZIL_OFFSET_MS);
}

const _pad = (n) => String(n).padStart(2, '0');

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return `${_pad(date.getDate())}/${_pad(date.getMonth() + 1)}/${date.getFullYear()} ${_pad(date.getHours())}:${_pad(date.getMinutes())}`;
}

export const formatOnlyDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return `${_pad(date.getDate())}/${_pad(date.getMonth() + 1)}/${date.getFullYear()}`;
};

// Returns today's date in Brazil time as "YYYY-MM-DD"
export const getBrazilDateString = () => {
  const d = _brazilDate();
  return `${d.getUTCFullYear()}-${_pad(d.getUTCMonth() + 1)}-${_pad(d.getUTCDate())}`;
};

// Returns a plain ISO datetime string for the current Brazil time (no 'Z' suffix),
// safe for LocalDateTime deserialization on the backend.
export const ajustedDate = () => {
  const d = _brazilDate();
  return `${d.getUTCFullYear()}-${_pad(d.getUTCMonth() + 1)}-${_pad(d.getUTCDate())}T${_pad(d.getUTCHours())}:${_pad(d.getUTCMinutes())}:${_pad(d.getUTCSeconds())}`;
}

// Returns the start of today in Brazil time as "YYYY-MM-DDT00:00:01"
export const getToday = () => {
  return getBrazilDateString() + 'T00:00:01';
}

// Returns the current Brazil datetime as "YYYY-MM-DDTHH:mm:ss"
export const getCurrentTimestamp = () => {
  return ajustedDate();
}

// Parse a date string safely: "YYYY-MM-DD" is treated as local midnight (not UTC midnight).
function _parseToLocal(input) {
  if (!input) return new Date(NaN);
  if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(input)) {
    return new Date(input + 'T00:00:00');
  }
  return new Date(input);
}

function toIsoLocal(date) {
  return date.getFullYear() +
    '-' + _pad(date.getMonth() + 1) +
    '-' + _pad(date.getDate()) +
    'T' + _pad(date.getHours()) +
    ':' + _pad(date.getMinutes()) +
    ':' + _pad(date.getSeconds());
}

export function createDateRange(startInput, endInput) {
  let start, end;

  if (startInput && endInput) {
    start = toIsoLocal(_parseToLocal(startInput));
    end = toIsoLocal(_parseToLocal(endInput));
  } else if (startInput && !endInput) {
    const startDate = _parseToLocal(startInput);
    const endOfStartDay = new Date(
      startDate.getFullYear(), startDate.getMonth(), startDate.getDate(),
      23, 59, 59, 0
    );
    start = toIsoLocal(startDate);
    end = toIsoLocal(endOfStartDay);
  } else if (!startInput && endInput) {
    const endDate = _parseToLocal(endInput);
    const startOfEndDay = new Date(
      endDate.getFullYear(), endDate.getMonth(), endDate.getDate(),
      0, 0, 0, 0
    );
    start = toIsoLocal(startOfEndDay);
    end = toIsoLocal(endDate);
  } else {
    const todayStr = getBrazilDateString();
    start = todayStr + 'T00:00:00';
    end = todayStr + 'T23:59:59';
  }

  return { start, end };
}
